/**
 * P3-38: VoidSpaceWgt —— 虚空空间面板。
 *
 * 对齐 `js/time.js:1871-1907`：
 * - FixCryochamberBtn
 * - voidspaceUpgrades 列表
 */
import { useGameTick } from "../../bridge/useGameTick";
import type { GamePage } from "../../bridge/GameBridge";
import { SpacePanel } from "../space/SpacePanel";
import FixCryochamberBtn from "./FixCryochamberBtn";
import TimeUpgradeBtn from "./TimeUpgradeBtn";

interface VoidSpaceSnapshot {
  visible: boolean;
  upgrades: { name: string }[];
}

function getSnapshot(game: GamePage | null): VoidSpaceSnapshot | null {
  if (!game) {
    return null;
  }
  const hasVS =
    (game.science?.get?.("voidSpace")?.researched ?? false) ||
    (game.time?.getVSU?.("usedCryochambers")?.val ?? 0) > 0;
  const upgrades = (game.time?.voidspaceUpgrades ?? []) as { name: string }[];
  return { visible: hasVS, upgrades };
}

function snapEq(a: VoidSpaceSnapshot | null, b: VoidSpaceSnapshot | null): boolean {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  if (a.visible !== b.visible || a.upgrades.length !== b.upgrades.length) {
    return false;
  }
  for (let i = 0; i < a.upgrades.length; i++) {
    if (a.upgrades[i].name !== b.upgrades[i].name) {
      return false;
    }
  }
  return true;
}

export default function VoidSpaceWgt() {
  const snapshot = useGameTick(
    (game) => getSnapshot(game as GamePage | null),
    snapEq,
  );

  if (!snapshot || !snapshot.visible) {
    return null;
  }

  return (
    <SpacePanel title="science.voidSpace.label">
      <div style={{ paddingTop: "20px" }}>
        <FixCryochamberBtn />
        {snapshot.upgrades.map((upgrade) => (
          <TimeUpgradeBtn key={upgrade.name} id={upgrade.name} type="voidSpace" />
        ))}
      </div>
    </SpacePanel>
  );
}
